<notchmark-header />
<main class="content">
  <router-outlet />
</main>
<notchmark-footer />